import mainLogo from '../../images/FiatValore/fiatValore_logo_color_white.png';
import squareLogo from '../../images/FiatValore/logo_fiat.webp';
import squareLogoColor from '../../images/FiatValore/fiatValore_logo_black.png';
import mainLogoColor from '../../images/FiatValore/fiatValore_logo_black.png';
import banner01 from '../../images/FiatValore/valoreFiat_banner_01.jpg';
import banner02 from '../../images/FiatValore/valoreFiat_banner_02.jpg';
import banner03 from '../../images/FiatValore/valoreFiat_banner_03.jpg';
import car123 from '../../images/FiatValore/123_pulse.jpg';
import box123 from '../../images/FiatValore/123_valorefiat.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Fiat Valore',
    defaultStoreLink: 'pecas.valorefiat.com.br',
    defaultContactEmail: 'vendasonline.valore@grupolider.com.br',
    whatsappNumber: '31 3319 9053',
    CNPJ: '21.483.615/0010-87',
    CNPJname: 'VALORE BETIM (ORLY VEICULOS E PECAS S. A.)',
    CNPJaddress: 'Avenida Bandeirantes, 1457 - CHACARA, BETIM - MG, 32670-355',
    launchDate: '30/05/2025',

    multiContact: {},

    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "fiat",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        'ORLY FIAT BETIM',
        'ORLY VALORE FIAT - ITAGUAI',
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Luzes',
        //     img: 'tabLuzes',
        //     products: SliderProducts.Luzes
        // },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: mainLogo,

    banner01: banner01,
    banner02: banner02,
    bannerBrands: '',
    aboutUsBg: banner03,


    car123: car123,
    box123: box123,
    
    paymentImg: mainLogoColor,
    paymentImgMobile: mainLogoColor,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu Fiat. Peças <mark>genuínas</mark> direto das concessionárias <mark>Fiat Valore</mark>.',

    aboutUs: {
        title: 'O Grupo Lider',
        content: [
            'A história do GRUPO LIDER começou em 1957, com a entrada em operação de sua primeira empresa, o Rodoviário Lider, em Muriaé, Zona da Mata de Minas Gerais. Inicialmente focada no transporte de leite "in natura" e cargas frigorificadas, a empresa teve um crescimento contínuo e equilibrado, fruto de uma administração segura e competente.',
            'Hoje, o GRUPO LIDER é um conglomerado de empresas modernas, adaptadas às constantes mudanças da economia brasileira e com diversos investimentos nos setores de comércio e serviços. Suas bases estão assentadas nos Estados de Minas Gerais, Rio de Janeiro e Espírito Santo.',
            'Consolidado como um dos maiores grupos corporativos do país, a trajetória de crescimento do GRUPO LIDER está associada a uma história de credibilidade, com ampla visão de futuro, atualização e modernização da infra-estrutura das empresas, comprometimento com seus valores humanos e respeito aos seus clientes.',
        ],
        link: 'https://www.valorefiat.com.br/fiat-betim/fale-conosco/sobre',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/valorefiat/',
        Facebook: 'https://www.facebook.com/valorefiat',
        LinkedIn: '',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}